module.exports = __webpack_public_path__ + "static/media/swingBottomFrame.024f670e.png";